import * as React from "react";
import { FormattedMessage } from "react-intl";
import { Modal } from "react-bootstrap";
import { translate } from "@/components/IntlProviderWrapper";
import { getBackend } from "@/lib/backend/Backend2";
import ErrorComponent from "@/components/ErrorComponent";

type Props = {
    show: boolean;
    onHide: () => void;
    calendar_line_options: CalendarLineOption[];
    calendar_line: string;
};

type State = {
    calendar_line_option_label: string;
    error: string;
};

type CalendarLineOption = {
    value: string;
    label: string;
};

const CALENDAR_LINE_OPTIONS_FILENAME = "calendar_line_options.json";

class LineDetailsSaveShiftModal extends React.Component<Props, State> {
    state: State = {
        calendar_line_option_label: "",
        error: "",
    };

    handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const target = event.currentTarget;
        this.setState({ error: "" });
        // read new values
        const value = target.value;
        const name = target.name;
        if (name === "calendar_line_option_label") {
            this.setState({ calendar_line_option_label: value });
        }
    };

    saveCalendarLineOption = async () => {
        if (this.state.calendar_line_option_label === "") {
            this.setState({
                error: translate("Calendar_line.enter_name_of_schedule", "Please enter name of schedule"),
            });
            return;
        }

        const calendar_line_options = this.props.calendar_line_options;

        // check if this calendar line option label already exists
        const found = calendar_line_options.find(option => option.label === this.state.calendar_line_option_label);

        if (found) {
            this.setState({
                error: translate(
                    "Calendar_line.schedule_with_this_name_already_exists",
                    "Schedule with this name already exists. Please enter another name"
                ),
            });
            return;
        } else {
            // At this point we have a label for this calendar line option
            calendar_line_options.push({
                value: this.props.calendar_line,
                label: this.state.calendar_line_option_label,
            });
            try {
                // save it to blob storage
                await getBackend().common.setBlobStorageItemAsString({
                    key: CALENDAR_LINE_OPTIONS_FILENAME,
                    content: JSON.stringify(calendar_line_options),
                });
            } catch (error) {
                this.setState({ error: translate("common.error", "An error occured while fetching data") });
            }

            // close modal after reseting state
            this.closeModal();
        }
    };

    closeModal = () => {
        this.setState({ calendar_line_option_label: "" }, () => {
            this.props.onHide();
        });
    };

    render() {
        return (
            <Modal show={this.props.show} onHide={this.props.onHide}>
                <Modal.Header>
                    <Modal.Title as={"div"}>
                        <h5>{translate("Calendar_line.save_schedule_as", "Save this schedule as...")}</h5>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <input
                        type="text"
                        className="form-control"
                        placeholder={translate("Calendar_line.enter_name_of_schedule", "Please enter name of schedule")}
                        autoFocus
                        name="calendar_line_option_label"
                        value={this.state.calendar_line_option_label}
                        onChange={this.handleInputChange}
                    />
                    {this.state.error !== "" ? <ErrorComponent msg={this.state.error} type="error" /> : null}
                </Modal.Body>
                <Modal.Footer>
                    <button onClick={this.closeModal} className="btn btn-outline-secondary">
                        <FormattedMessage id="common.cancel" defaultMessage="Cancel" />
                    </button>
                    <button onClick={this.saveCalendarLineOption} className="btn btn-primary">
                        <FormattedMessage id="common.save" defaultMessage="Save" />
                    </button>
                </Modal.Footer>
            </Modal>
        );
    }
}

export default LineDetailsSaveShiftModal;
